import type { EntityRootData } from '../../types/entities';

/**
 * Retrieves the domainEntityId of an entity from the provided data based on whether the BE is enabled.
 *
 * @param data - The root data containing entity information. It can be undefined.
 * @param isConfigAppBackendEnabled - A boolean indicating if the Config App Backend is enabled.
 * @returns The domainEntityId
 */

export const getDomainEntityId = (
  data: EntityRootData | undefined,
  isConfigAppBackendEnabled: boolean,
) => {
  if (!isConfigAppBackendEnabled) {
    return data?.id;
  }

  return data?.attributes?.entityMetadata?.domainEntityId;
};
